import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import ModalComponent from '@BUP/components/Generics/Modal'
import CreatePasswordForm from '@BUP/components/MySchool/CreatePasswordForm'
import { useCreatePassword } from '@BUP/hooks/user/useCreatePassword'
import { useTranslation } from 'react-i18next'

const CreateUserButton = ({ user }) => {
  const i18n = useTranslation()
  const {
    loading: loadingCreatePassword,
    createPassword,
    isOpenModalCreatePassword,
    selectedUser,
    startCreateUserPassword,
    setIsOpenModalCreatePassword
  } = useCreatePassword()

  return (
    <>
      <ButtonComponent
        colorType='primary'
        size='small'
        onClick={() => startCreateUserPassword(user)}
        buttonText={i18n.t('common.resources.user.actions.create.password.submit')}
      />
      <ModalComponent
        headerText={i18n.t('common.resources.user.actions.create.password.submit')}
        stateModal={isOpenModalCreatePassword}
        header
        modalDescription={
          <CreatePasswordForm
            loading={loadingCreatePassword}
            onCreatePassword={createPassword}
            selectedUser={selectedUser}
          />
        }
        showButtons={false}
        onClickCloseModal={() => setIsOpenModalCreatePassword(false)}
      />
    </>
  )
}

export default CreateUserButton
